import navBar from './components/nav-bar/index.vue'

export default {
  name: 'profile',
  components: {
    navBar,
  },
}
